/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreatePaymentRequest = {
    /**
     * ID of the package to pay for
     */
    packageId: number;
    /**
     * Type of package (PACKAGE or COMBINED)
     */
    packType: CreatePaymentRequest.packType;
    /**
     * ID of the receiver's address for shipping
     */
    AddressId?: number;
};
export namespace CreatePaymentRequest {
    /**
     * Type of package (PACKAGE or COMBINED)
     */
    export enum packType {
        PACKAGE = 'PACKAGE',
        COMB_PACKAGE = 'COMB_PACKAGE',
    }
}

